import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';

@Injectable({
    providedIn: 'root'
})
export class JobListService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    getJobStatusList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobStatusListEndPoint)).toPromise();
    }

    getJobTypeList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.wsJobTypeListEndPoint)).toPromise();
    }

    getJobList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.serviceJobListEndPoint)).toPromise();
    }

    getMeterReadingTypes() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.meterTypeListEndPoint)).toPromise();
    }

    getMeterMandatoryReading() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getWsJobTemplateToWsNamedMeterBeansEndPoint)).toPromise();
    }

    getJobCertificates() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobCertificateTextEndPoint)).toPromise();
    }

    getJobTemplate() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobTemplateEndPoint)).toPromise();
    }

    getTasksList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.wsTasksEndPoint)).toPromise();
    }

    getJobHistory(id) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobHistoryEndPoint + id)).toPromise();
    }
}
